import PhoneInput from './phoneInput';

export default PhoneInput;
